export default __webpack_public_path__ + "static/media/google.65edb6e1.png";